export default __webpack_public_path__ + "static/media/lds-logo_zh.dc58e08b160a3eb1.svg";